'use client'

import { cmsTermsFromProfile } from '@/components/termsRestrictions/cmsTerms'
import { getTermsPoints } from '@/components/termsRestrictions/termsPoints/getTermsPoints'
import { TermsRestrictions } from '@/components/termsRestrictions/TermsRestrictions'
import type { CmsSellerProfile } from '@/helpers/api/fetchPayload'

import { useSellerProfileLivePreview } from './useSellerProfileLivePreview'

/** The Terms of Purchase page inside the Live Preview pane: its points follow the admin form. */
export default function TermsRestrictionsLivePreview({
  profile,
  serverURL,
  sellerSlug,
  policy,
  storeFrontName,
  termsDisplayName,
  termsDocUrl,
}: {
  profile: CmsSellerProfile
  serverURL: string
  sellerSlug: string
  policy: string
  storeFrontName: string
  termsDisplayName?: string
  termsDocUrl?: string
}) {
  const data = useSellerProfileLivePreview(profile, serverURL)
  return (
    <TermsRestrictions
      policy={policy}
      storeFrontName={storeFrontName}
      sellerDisplayName={storeFrontName}
      termsDisplayName={termsDisplayName}
      termsDocUrl={termsDocUrl}
      termsPoints={getTermsPoints({
        sellerSlug,
        termsDisplayName,
        termsDocUrl,
        cmsTerms: cmsTermsFromProfile(data),
      })}
    />
  )
}
